"use strict";function bind$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.bind$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.bind";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.34"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.34"},_a)),exports.bind$=bind$,exports.default=bind$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/bind.js
// module id = 955
// module chunks = 106